import api from '../../services/api-service';
import { apiUrl } from '../../constants/api-urls';
import {showLoader,hideLoader} from  './../common/loader/action';
import loadjs from 'loadjs';

const isMobile = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (
      userAgent && (userAgent.match(/android/i)
  || userAgent.match(/webos/i)
  || userAgent.match(/iphone/i)
  || userAgent.match(/blackberry/i)
  || userAgent.match(/windows phone/i)
  || userAgent.match(/my_vzw_app/i))
    ) {
      return true;
    } return false;
  };
  
  const viewport = () => {
    if (isMobile()) {
      return 'mobile';
    } return 'desktop';
  };
  
const getTaggingChannelId = () => {
    let channelId = 'VZW-DOTCOM';
    if (viewport() === 'mobile' || viewport() === 'mfapp') {
      if (window.navigator.userAgent.indexOf('VZW-MFA-IOS') > -1) {
        channelId = 'VZW-MFA-IOS';
      } else if (window.navigator.userAgent.indexOf('VZW-MFA-ANDROID') > -1) {
        channelId = 'VZW-MFA-ANDROID';
      } else {
        channelId = 'VZW-DOTCOM-MOB';
      }
    }
    return channelId;
  };
  const mockData =  {
    "data":{
      "coverageDetails":
      {"returnCode":"0","returnName":"0","returnMessage":"SUCCESS","returnStatus":"SUCCESS",
      "result":
      {"product":
      "C-BAND","locationLatitude":28.075154,"locationLongitude":-82.447474,"baseLocationId":3.00163904447E11,
      "serviceAddress":"14005 SANDY CT APT A, TAMPA, FL, 33613-3440, USA",
      "nodes":[
        {"priority":1.0,"latitude":28.073531,"longitude":-82.4505,"baseStation":"1447406","sector":"2","throughput":100.0,"is_cband":true},
        {"priority":2.0,"latitude":27.674681,"longitude":-81.505300,"baseStation":"1447406","sector":"1","throughput":100.0,"is_cband":true}],
      "cpeThresholds":[{"sku":"ASK-NCQ1338","threshold":-123.0}]}},
      "address":{"line1":"14005 SANDY CT APT A","city":"TAMPA","state":"FL","zip":"33613"}}
}
const Data = {
  "data": {
      "coverageDetails": {
          "result": {
              "product": "MMW",
              "locationLatitude": 29.7373608172889,
              "locationLongitude": -95.371996384154,
              "serviceAddress": "1616 STUART ST HOUSTON TX 77004-2945 USA",
              "nodes": [
                {
                    "latitude": 29.739595,
                    "longitude": -95.374978,
                    "is_cband": false,
                    "exposure": {
                        "coordinates": [
                            [
                                -95.37218165669363,
                                29.737459207526364
                            ],
                            [
                                -95.37215311087795,
                                29.737495281840413
                            ]
                        ]
                    }
                }
              ]
          }
      }
  }
}
export const coverageDetails = (dispatch) => {
  let url = apiUrl().coverageDetails;
  const params = new URLSearchParams(window.location.search);
  const order = params.get('orderNumber');
  const orderNumber = order && order.replace(/ /g, '+');
  const location = params.get('locationCode');
  const locationCode = location && location.replace(/ /g, '+');
  const path = window.location.pathname;
  const NBType = params.get('NetworkBandWidthType');
  const NetworkBandWidthType = NBType === 'MMW' ? true : false;
  const mmwv = path.includes('verizon-receiver') || NetworkBandWidthType ? true : false;
  let payLoad = {
    "base_location_id": null,
    "order": {
      "orderNumber": orderNumber,
      "locationCode": locationCode,
      "mdn": null,
      "mmwv": mmwv
    }
  } 
  let reqHead = {
    channelId: getTaggingChannelId()
  }
  if(!orderNumber){
    return true
  }
  dispatch(showLoader());
  api(url, 'POST', payLoad, reqHead).then((response) =>{  
    dispatch({
      type: 'COVERAGE_DETAILS',
      address: response.data.address ? response.data.address : '',
      nodes: response.data.coverageDetails.result.nodes ? response.data.coverageDetails.result.nodes : [],
      lat: response.data.coverageDetails.result.locationLatitude ? response.data.coverageDetails.result.locationLatitude : '',
      lgt: response.data.coverageDetails.result.locationLongitude ? response.data.coverageDetails.result.locationLongitude : '',
      coords: response.data.coverageDetails.result.nodes[0].exposure ? response.data.coverageDetails.result.nodes[0].exposure.coordinates : [],
      serviceAddress : response.data.coverageDetails.result.serviceAddress ? response.data.coverageDetails.result.serviceAddress : ''
    })
    dispatch(hideLoader());
  })
    .catch(error => {
      dispatch(hideLoader());
      if (window.location.host.includes('localhost')) {
        dispatch({
          type: 'COVERAGE_DETAILS',
          address: mockData.data.address,
          nodes: mockData.data.coverageDetails.result.nodes,
           lat: mockData.data.coverageDetails.result.locationLatitude,
           lgt: mockData.data.coverageDetails.result.locationLongitude,
        // lat: Data.data.coverageDetails.result.locationLatitude,
        // lgt: Data.data.coverageDetails.result.locationLongitude,
        // coords: Data.data.coverageDetails.result.nodes[0].exposure ? Data.data.coverageDetails.result.nodes[0].exposure.coordinates : [],
        // serviceAddress : Data.data.coverageDetails.result.serviceAddress ? Data.data.coverageDetails.result.serviceAddress : ''
        })
      }
    }
    )
}
const mapCoreScript = () => 'https://js.api.here.com/v3/3.1/mapsjs-core.js';
const mapServiceScript = () => 'https://js.api.here.com/v3/3.1/mapsjs-service.js';
const mapUiScript = () => 'https://js.api.here.com/v3/3.1/mapsjs-ui.js';
const mapEventsScript = () => 'https://js.api.here.com/v3/3.1/mapsjs-mapevents.js';
// Dummy Check-in

export const invokeHereMapScript = () => {
  loadjs(mapCoreScript(), { returnPromise: true })
    .then(() => {
      console.log('mapCore is loaded successfully');
      loadjs(mapServiceScript(), { returnPromise: true })
        .then(() => {
          console.log('mapService is loaded successfully');
          loadjs(mapUiScript(), { returnPromise: true })
            .then(() => {
              console.log('mapUi is loaded successfully');
              loadjs(mapEventsScript(), { returnPromise: true })
                .then(() => {
                  console.log('mapEvent is loaded successfully');
                })
                .catch(() => {
                  console.log('mapEvent is loaded successfully');
                });
            })
            .catch(() => {
              console.log('mapUi is loaded successfully');
            });
        })
        .catch(() => {
          console.log('mapService is loaded successfully');
        });
    })
    .catch(() => {
      console.log('mapCore is loaded successfully');
    });

  const style = document.createElement('link');
  style.href = 'https://js.api.here.com/v3/3.1/mapsjs-ui.css';
  style.rel = 'stylesheet';
  style.text = 'text/css';
  document.head.appendChild(style);
};


